export default __webpack_public_path__ + "static/media/paperFlat.65613650.jpg";